module.exports = __webpack_public_path__ + "static/media/sku219400940.13369b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/sku219400940.png
// module id = 545
// module chunks = 0